function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function createToggleButton(controlledBlock) {
    if (!controlledBlock.id) {
        controlledBlock.id = `text-truncate-lines-${crypto.randomUUID()}`;
    }

    const button = document.createElement("button");
    button.type = "button";
    button.className = "btn btn-link2 text-truncate-toggle";
    button.textContent = controlledBlock.dataset.truncateTextShowMore || "Show more";
    button.setAttribute("aria-controls", controlledBlock.id);
    return button;
}

// Elements we've already attached a ResizeObserver to - guards against
// processing the same element twice (e.g. if it's matched by both the
// initial scan and the MutationObserver).
const observedElements = new WeakSet();

function evaluateTruncation(truncatedBlock) {
    // while expanded, line-clamp is unset so we have to remove the class to re-evaluate
    var expanded = truncatedBlock.classList.contains("expanded");
    truncatedBlock.classList.remove("expanded");

    const isTruncated = truncatedBlock.scrollHeight > truncatedBlock.clientHeight;
    const existingToggle = truncatedBlock.nextElementSibling && truncatedBlock.nextElementSibling.classList.contains("text-truncate-toggle")
        ? truncatedBlock.nextElementSibling
        : null;

    if (isTruncated) {
        // still truncated (or newly truncated) - make sure a toggle button is present
        if (!existingToggle) {
            insertAfter(truncatedBlock, createToggleButton(truncatedBlock));
        }
    } else if (existingToggle) {
        // no longer truncated (e.g. panel widened) - remove the toggle button
        existingToggle.remove();
    }

    if(expanded) {
        truncatedBlock.classList.add("expanded");
    }
}

function observeElement(truncatedBlock) {
    if (observedElements.has(truncatedBlock)) return;

    observedElements.add(truncatedBlock);

    const resizeObserver = new ResizeObserver(() => evaluateTruncation(truncatedBlock));

    resizeObserver.observe(truncatedBlock);
}

// Delegated click handling - keeps working even if Angular or evaluateTruncation()
// removes/recreates the toggle button.
document.addEventListener("click", function (e) {
    const toggle = e.target.closest(".text-truncate-toggle");

    if (!toggle) return;

    const truncatedBlock = toggle.previousElementSibling;

    const expanded = truncatedBlock.classList.toggle("expanded");

    toggle.textContent = expanded
        ? (truncatedBlock.dataset.truncateTextShowLess || "Show less")
        : (truncatedBlock.dataset.truncateTextShowMore || "Show more");
});

export function init(selector) {
    const targetSelector = selector || "[data-truncate-text-toggle]";

    document.querySelectorAll(targetSelector).forEach(observeElement);

    const mutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== Node.ELEMENT_NODE) return;

                if (node.matches && node.matches(targetSelector)) {
                    observeElement(node);
                }

                if (node.querySelectorAll) {
                    node.querySelectorAll(targetSelector).forEach(observeElement);
                }
            });
        });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
}

export default { init };
